import { AppProviders } from "@/app/providers";
import { router } from "@/app/router";
import { applyTheme, readTheme } from "@/lib/preferences";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import "@/styles/theme.css";

// Paint the correct theme before React mounts to avoid a flash of the wrong mode.
applyTheme(readTheme());

const container = document.getElementById("root");
if (!container) throw new Error("Root container #root is missing from index.html.");

createRoot(container).render(
  <StrictMode>
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  </StrictMode>,
);
